import { useEffect, useState } from "react";
import { Drawer, IconButton } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "react-router-dom";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { getImageById } from "../../commons/constants/helpers";
import { IProps } from "../../types/CommonTypes";
import "./landing.css";

export const NAV_LINKS = [
	{ href: "#inicio", label: "Inicio" },
	{ href: "#about", label: "Sobre mí" },
	{ href: "#blogs", label: "Noticias" },
	{ href: "#gestion", label: "Gestión" },
	{ href: "#denuncias", label: "Denuncias" },
	{ href: "#podcast", label: "Pódcast" },
];

const Header = ({ item }: IProps) => {
	const [scrolled, setScrolled] = useState(false);
	const [open, setOpen] = useState(false);
	const [isLogged, setIsLogged] = useState(false);
	const navigate = useNavigate();
	const logo = getImageById("name2", item);

	useEffect(() => {
		// currentUser es null en el primer render aunque haya sesión activa:
		// hay que esperar a que Firebase restaure el estado de autenticación.
		return onAuthStateChanged(getAuth(), (user) => setIsLogged(!!user));
	}, []);

	useEffect(() => {
		const onScroll = () => setScrolled(window.scrollY > 40);
		onScroll();
		window.addEventListener("scroll", onScroll, { passive: true });
		return () => window.removeEventListener("scroll", onScroll);
	}, []);

	return (
		<header
			className={`ld-header ${scrolled ? "ld-header-scrolled" : ""}`}
		>
			<div className="ld-container ld-header-inner">
				<a href="#inicio" className="ld-header-logo">
					<img src={logo} alt="Daniel Briceño — Control con verdad" />
				</a>

				<nav className="ld-header-nav" aria-label="Secciones">
					{NAV_LINKS.map((link) => (
						<a key={link.href} href={link.href}>
							{link.label}
						</a>
					))}
				</nav>

				<a className="ld-btn ld-btn-yellow ld-header-cta" href="#denuncias">
					Denuncia aquí
				</a>

				<IconButton
					className="ld-header-burger"
					aria-label="Abrir menú"
					onClick={() => setOpen(true)}
					sx={{ color: "white" }}
				>
					<MenuIcon fontSize="large" />
				</IconButton>
			</div>

			<Drawer
				anchor="right"
				open={open}
				onClose={() => setOpen(false)}
				PaperProps={{
					sx: {
						bgcolor: "#081C3E",
						color: "#fff",
						width: "min(320px, 84vw)",
					},
				}}
			>
				<div style={{ display: "flex", justifyContent: "flex-end", padding: 8 }}>
					<IconButton
						aria-label="Cerrar menú"
						onClick={() => setOpen(false)}
						sx={{ color: "white" }}
					>
						<CloseIcon />
					</IconButton>
				</div>
				<nav className="ld-drawer-nav" aria-label="Secciones">
					{NAV_LINKS.map((link) => (
						<a
							key={link.href}
							href={link.href}
							onClick={() => setOpen(false)}
						>
							{link.label}
						</a>
					))}
				</nav>
				<button
					className="ld-drawer-login"
					onClick={() => {
						setOpen(false);
						navigate("/login");
					}}
				>
					{isLogged ? "Ir al dashboard" : "Iniciar sesión"}
				</button>
			</Drawer>
		</header>
	);
};

export default Header;
